import { render, staticRenderFns } from "./newsLetterDetail.vue?vue&type=template&id=3c97b1d6"
import script from "./newsLetterDetail.vue?vue&type=script&lang=js"
export * from "./newsLetterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports